<div pl-grid="loose margin">
  <div pl-grid-el pl-grid="1/1@phone">
    @if (this.order.child_sales?.length > 0) {
      <se-fe-card
        class="pl-text--left">
        <se-fe-card-header seFeDataTitle="Related orders"></se-fe-card-header>
        <se-fe-card-content>
          @for (child of order.child_sales; track child; let i = $index) {
            <div
              pl-grid="1/1@phone tight nowrap align-baseline">
              <div>
                <p class="pl-help-text bold">
                  <a href="{{ childLinks[i] }}" target="_blank" class="pl-link">
                    Sale {{ child.sale_number }}
                  </a>
                </p>
              </div>
            </div>
          }
        </se-fe-card-content>
      </se-fe-card>
    }
    @if (order.parent_sale) {
      <se-fe-card
        class="pl-text--left">
        <se-fe-card-header seFeDataTitle="Original order"></se-fe-card-header>
        <se-fe-card-content>
          <div pl-grid="1/1@phone tight nowrap align-baseline">
            <div>
              <p class="pl-help-text bold">
                <a href="{{ parentLink }}" target="_blank" class="pl-link">
                  Sale {{ order.parent_sale.sale_number }}
                </a>
              </p>
            </div>
          </div>
        </se-fe-card-content>
      </se-fe-card>
    }
  </div>
</div>
